import { render, staticRenderFns } from "./OrderCustomerUnderway.vue?vue&type=template&id=2905a1e4&"
import script from "./OrderCustomerUnderway.vue?vue&type=script&lang=ts&"
export * from "./OrderCustomerUnderway.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports